<template>
  <div class="home-page">
    <!-- 页眉部分 -->
    <header>
      <div class="lab-header">
        <img
          :src="labLogo"
          alt="实验室logo"
          class="lab-logo"
          @error="setDefaultLogo($event, 'lab')"
        />
        <div class="lab-title">
          <h1>人工智能和机器人实验室</h1>
          <p>AI and Robotic Systems Lab</p>
        </div>
      </div>

      <div class="sz-header">
        <div class="sz-logos">
          <img
            :src="uestcLogo"
            alt="电子科技大学"
            class="sz-logo"
            @error="setDefaultLogo($event)"
          />
          <img
            :src="uestcSzLogo"
            alt="电子科技大学（深圳）高等研究院"
            class="sz-logo"
            @error="setDefaultLogo($event)"
          />
        </div>
        <div class="sz-links">
          <a href="https://uestc.edu.cn" class="sz-link" target="_blank"
            >电子科技大学</a
          >
          <span class="sz-separator">|</span>
          <a href="https://sz.uestc.edu.cn" class="sz-link" target="_blank"
            >电子科技大学（深圳）高等研究院</a
          >
        </div>
        <div class="language-switcher">
          <a href="about.html" class="language-btn active">中文</a>
          <a href="about-en.html" class="language-btn">EN</a>
        </div>
      </div>
    </header>

    <!-- 导航菜单 -->
    <nav>
      <ul>
        <li>
          <a
            :class="{ active: $route.name === 'home' }"
            @click.prevent="$router.push({ name: 'home' })"
            >首页</a
          >
        </li>
        <li>
          <a
            :class="{ active: $route.name === 'about' }"
            @click.prevent="$router.push({ name: 'about' })"
            >实验室概况</a
          >
        </li>
        <li>
          <a
            :class="{ active: $route.name === 'team' }"
            @click.prevent="$router.push({ name: 'team' })"
            >学术团队</a
          >
        </li>
        <li>
          <a
            :class="{ active: $route.name === 'research' }"
            @click.prevent="$router.push({ name: 'research' })"
            >科研成果</a
          >
        </li>
        <li>
          <a
            :class="{ active: $route.name === 'recruitment' }"
            @click.prevent="$router.push({ name: 'recruitment' })"
            >招生与就业</a
          >
        </li>
        <li>
          <a
            href="https://partner.example.com"
            target="_blank"
            rel="noopener"
            >合作企业</a
          >
        </li>
        <li>
          <a
            :class="{ active: $route.name === 'contact' }"
            @click.prevent="$router.push({ name: 'contact' })"
            >联系我们</a
          >
        </li>
      </ul>
    </nav>


    <!-- 英雄区域 -->
    <div class="hero">
      <div class="hero-content">
        <h1>欢迎来到XXX实验室</h1>
        <p>探索前沿科技，共创美好未来</p>
      </div>
    </div>

    <!-- 主要内容 -->
    <div class="main-content">
      <div class="home-container">
        <!-- 左侧联系信息 -->
        <div class="contact-info">
          <h3 class="contact-title">团队主任联系方式</h3>
          <div class="contact-item">
            <span class="contact-label">姓名：</span>
            <span>范教授</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">职称：</span>
            <span>教授/博士生导师</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">电话：</span>
            <span>XXX-12345678</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">邮箱：</span>
            <span>director@xxx-lab.edu.cn</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">办公室：</span>
            <span>科研楼A座501室</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">办公时间：</span>
            <span>周一至周五 9:00-17:00</span>
          </div>
        </div>

        <!-- 右侧通知/新闻 -->
        <div class="right-content">
          <div class="info-box">
            <h3 class="box-title">通知公告</h3>
            <div class="info-list">
              <div class="info-item" v-for="item in notices" :key="item.date">
                <span class="info-date">{{ item.date }}</span>
                <a href="#" class="info-title">{{ item.title }}</a>
              </div>
            </div>
          </div>

          <div class="info-box">
            <h3 class="box-title">每日推荐</h3>
            <div class="info-list">
              <div class="info-item" v-for="item in news" :key="item.date">
                <span class="info-date">{{ item.date }}</span>
                <a href="#" class="info-title">{{ item.title }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <footer>
      <div class="footer-links">
        <a href="about.html">关于我们</a>
        <a href="research.html">研究成果</a>
        <a href="partners.html">合作交流</a>
        <a href="contact.html">联系我们</a>
      </div>
      <p>© 2025 人工智能和机器人实验室 版权所有</p>
      <p>
        地址：深圳市龙华区观澜街道观光路 | 电话：XXX-12345678 |
        邮箱：contact@xxx-lab.edu.cn
      </p>
    </footer>
  </div>
</template>

<script>
import defaultLogo from "@/assets/default-logo.png";

export default {
  name: "HomePage",
  data() {
    return {
      labLogo: "lab-logo.png",
      uestcLogo: "uestc-logo.png",
      uestcSzLogo: "uestc-sz-logo.png",
      notices: [
        { date: "2025-08-01", title: "关于举办2025年度学术研讨会的通知" },
        { date: "2025-07-25", title: "实验室暑期开放时间安排" },
        { date: "2025-07-15", title: "2025年度科研项目申报指南" },
        { date: "2025-07-05", title: "实验室安全培训通知" },
        { date: "2025-06-28", title: "关于实验室设备维护的通知" },
      ],
      news: [
        { date: "2025-08-05", title: "实验室在Nature发表重要研究成果" },
        {
          date: "2025-07-30",
          title: "范教授团队获国家自然科学基金重点项目资助",
        },
        { date: "2025-07-20", title: "实验室与华为公司签署战略合作协议" },
        { date: "2025-07-10", title: "国际知名学者来访实验室进行学术交流" },
        { date: "2025-06-30", title: "实验室研究生在国际会议上获最佳论文奖" },
      ],
    };
  },
  methods: {
    setDefaultLogo(event) {
      event.target.src = defaultLogo;
    },
  },
};
</script>

<style scoped>

</style>
